import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'

export const AuthInternalSchema = z.object({
  sid: z.string(),
  createdAt: z.number(),
})
export type AuthInternal = ZodSimplify<typeof AuthInternalSchema>
